import React, { useEffect, useState } from "react";

const LottieAnimation = (props) => {
  const [Lottie, setLottie] = useState(null);

  useEffect(() => {
    import("lottie-react").then((mod) => setLottie(() => mod.default));
  }, []);

  if (!Lottie) return null;

  return <Lottie {...props} />;
};

export default LottieAnimation;
